import React from "react";
import Lottie from "react-lottie";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
import data from "asset/lottie/document/deposit/deposit_loading.json";
const DepositLoading = ({ width = 700, height = 50, style = {} }) => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Lottie
      options={{ loop: true, autoplay: true, animationData: data }}
      style={style}
      width={width}
      height={height}
      alt="icon"
    />
  );
};
export default DepositLoading;
